// Custom Alert System
(function() {
  'use strict';
  
  // 定数定義
  var ALERT_CONFIG = {
    CLASSES: {
      CLOSE: 'alert-close',
      MESSAGE: 'alert-message',
      SHOW: 'show',
      BODY_ACTIVE: 'custom-alert-active'
    },
    Z_INDEX: '10000'
  };
  
  var alertModal = null;
  var isOpen = false;
  var resolveAlert = null;

  // 共通イベント停止処理
  function stopEventPropagation(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  // HTMLテンプレート
  var ALERT_TEMPLATE = `
    <div id="custom-alert" class="alert-overlay" role="dialog" aria-modal="true" aria-hidden="true">
      <div class="alert-content">
        <button type="button" class="alert-close" aria-label="閉じる">&times;</button>
        <div class="alert-message"></div>
      </div>
    </div>
  `;

  // モーダル作成
  function createAlertModal() {
    if (document.getElementById('custom-alert')) {
      alertModal = document.getElementById('custom-alert');
      return;
    }

    document.body.insertAdjacentHTML('beforeend', ALERT_TEMPLATE);
    alertModal = document.getElementById('custom-alert');
    bindEvents();
  }

  // イベントバインド
  function bindEvents() {
    // 閉じるボタン - イベント伝播を停止
    var closeBtn = alertModal.querySelector('.' + ALERT_CONFIG.CLASSES.CLOSE);
    closeBtn.addEventListener('click', function(e) {
      stopEventPropagation(e);
      hideAlert();
    });
    
    // オーバーレイクリック - イベント伝播を停止して競合を防ぐ
    alertModal.addEventListener('click', function(e) {
      if (e.target === alertModal) {
        stopEventPropagation(e);
        hideAlert();
      }
    });

    // Escキー - capture phaseで先に処理して競合を防ぐ
    document.addEventListener('keydown', function(e) {
      if (isOpen && e.key === 'Escape') {
        stopEventPropagation(e);
        hideAlert();
      }
    }, true); // capture phase で処理
  }

  // アラート表示（Promiseを返す。モーダルが閉じられた時に resolve する）
  function showAlert(message) {
    // 入力値検証
    if (!message || typeof message !== 'string') {
      console.warn('Alert message must be a non-empty string');
      return Promise.resolve();
    }

    // モーダル作成
    createAlertModal();

    // メッセージ設定
    var messageEl = alertModal.querySelector('.' + ALERT_CONFIG.CLASSES.MESSAGE);
    messageEl.textContent = message;

    // 表示
    alertModal.setAttribute('aria-hidden', 'false');
    alertModal.classList.add(ALERT_CONFIG.CLASSES.SHOW);

    // アラート専用のbody class追加
    document.body.classList.add(ALERT_CONFIG.CLASSES.BODY_ACTIVE);

    // 最上位z-indexを設定
    alertModal.style.zIndex = ALERT_CONFIG.Z_INDEX;

    // フォーカス
    var closeBtn = alertModal.querySelector('.' + ALERT_CONFIG.CLASSES.CLOSE);
    closeBtn.focus();

    isOpen = true;

    return new Promise(function(resolve) {
      resolveAlert = resolve;
    });
  }

  // アラート非表示
  function hideAlert() {
    if (!isOpen || !alertModal) return;

    alertModal.classList.remove(ALERT_CONFIG.CLASSES.SHOW);
    alertModal.setAttribute('aria-hidden', 'true');

    // アラート専用のbody class削除
    document.body.classList.remove(ALERT_CONFIG.CLASSES.BODY_ACTIVE);

    isOpen = false;

    if (resolveAlert) {
      resolveAlert();
      resolveAlert = null;
    }
  }

  // グローバル関数として公開
  window.customAlert = showAlert;
  window.showMessage = showAlert;

  // 既存のalert関数を置き換える場合（オプション）
  window.alert = showAlert;

})();